import { render } from "./SideNavigation.vue?vue&type=template&id=055da05c&scoped=true"
import script from "./SideNavigation.vue?vue&type=script&lang=js"
export * from "./SideNavigation.vue?vue&type=script&lang=js"

import "./SideNavigation.vue?vue&type=style&index=0&id=055da05c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055da05c"]])

export default __exports__